module.exports = __webpack_public_path__ + "img/DiHS_Dashboard_Icon_Verbindung_ro.a452b49d.jpg";